import React from 'react';
import '../styles/ApplicationEnd.css';

const ApplicationEnd = () => {
  return (
    <div className="applicationend-container">
      <div className="applicationend-content">
        <div className="applicationend-text">
          <h1>Ready to transform your business?</h1>
          <p>
            Let's discuss how we can help you modernize your applications and build for the future.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ApplicationEnd;
